import EDC from '../globals';
import store from '@/store/index';
import Timer from '../timer';
import AnswersCounter from '../answers-counter';
import CursorManager from '../cursor-manager';
import { Summary } from '../summary';
import AboutScene from '../about';

EDC.Games.BaseMinigamesMain = function () {
  this.gameData = {};
  this.timer = null;
  this.answersCounter = null;
  this.cursorManager = null;
  // this.quickPanel = null;
  this.baseBackground = null;
};
/**
 *
 */
EDC.Games.BaseMinigamesMain.prototype.resetGameData = function () {
  this.gameData.errors = 0;
  this.gameData.correct = 0;
};
/**
 *
 */
EDC.Games.BaseMinigamesMain.prototype.runAdditionalScenes = function () {
  this.scene.launch('thumb');
  this.scene.get('thumb').setMainScene(this);

  this.scene.launch('ingame-menu');
  this.scene.get('ingame-menu').addControlScene(this);
  this.scene.get('ingame-menu').addControlScene(this.scene.get('thumb'));

  this.scene.add('about', AboutScene);
  this.scene.launch('about', { width: this.game.config.width, height: this.game.config.height });
};
/**
 *
 */
EDC.Games.BaseMinigamesMain.prototype.createBasicUI = function () {
  this.timer = new Timer(this);
  this.timer.create();

  this.answersCounter = new AnswersCounter(this);
  this.answersCounter.create();

  // this.quickPanel = new QuickPanel(this).create();
};
/**
 *
 */
EDC.Games.BaseMinigamesMain.prototype.playMusicList = function (index) {
  const list = this.gameConfig.musicList;
  if (list) {
    const songIndex = index;
    if (list[songIndex]) {
      const music = this.sound.add(`music-${list[songIndex]}`);
      music.play();
      music.once('complete', this.playMusicList.bind(this, songIndex + 1), this);
    } else {
      this.playMusicList(0);
    }
  } else {
    this.sound.play('music', { loop: true });
  }
};

EDC.Games.BaseMinigamesMain.prototype.initialize = function () {
  this.runAdditionalScenes();
  this.resetGameData();

  this.cursorManager = new CursorManager(this.game.canvas);

  if (store.getters.getSoundOn) {
    this.sound.setMute(false);
  } else {
    this.sound.setMute(true);
  }

  this.playMusicList(0);

  const bg = this.add.sprite(0, 0, 'background').setOrigin(0);
  bg.displayWidth = this.game.config.width;
  bg.displayHeight = this.game.config.height;
  this.baseBackground = bg;
};
/**
 *
 */
EDC.Games.BaseMinigamesMain.prototype.returnBaseBackground = function () {
  return this.baseBackground;
};
/**
 *
 */
EDC.Games.BaseMinigamesMain.prototype.showSummary = function () {
  const summaryData = {
    errors: this.gameData.errors,
    correct: this.gameData.correct,
    time: this.timer.getOverallSeconds(),
    date: new Date().toISOString(),
    difficulty: this.scene.difficulty || 1,
  };
  store
    .dispatch('gamesLogs/saveGameLogs', summaryData, { root: true })
    .then((data) => {
      store.dispatch('game/emitGameEnd');
      const summary = new Summary(this, 'background-blur', summaryData);
      summary.create(data);
      summary.show();
    })
    .catch((err) => {
      console.log(err);
      this.forceShowSummary(summaryData);
    });
};

EDC.Games.BaseMinigamesMain.prototype.forceShowSummary = function (summaryData) {
  const empty = [];
  const empty1 = null;
  const empty2 = null;
  const summary = new Summary(this, 'background-blur', summaryData);
  summary.create({ empty, empty1, empty2 });
  summary.show();
};
/**
 *
 */
EDC.Games.BaseMinigamesMain.prototype.playCorrect = function () {
  this.gameData.correct = this.gameData.correct + 1;
  this.scene.get('thumb').showCorrect();
  this.answersCounter.incrementCorrect();
};
/**
 *
 */
EDC.Games.BaseMinigamesMain.prototype.playWrong = function () {
  this.gameData.errors = this.gameData.errors + 1;
  this.scene.get('thumb').showWrong();
  this.answersCounter.incrementWrong();
};

export default EDC.Games.BaseMinigamesMain;
